import React, { use } from "react";
import { useAtom } from "jotai";
import ScreenCard from "../ScreenCard";
import { newMissionState } from "../../atoms/core";
import MissionJobTitle from "../../components/editors/MissionJobTitle";
import { CreateMissionScreensContext } from "../../contexts/CreateMissionManager";
import { useI18n } from "../../hooks/i18n-hooks";
import { Bubble } from "../../components/Bubble";
import { useBubbleStepOrigin } from "../../hooks/use-bubble-step-origin";

const CreateMissionJobTitle = () => {
    const i18n = useI18n();
    const [mission, setMission] = useAtom(newMissionState);
    const { validateScreen } = use(CreateMissionScreensContext);

    const validate = React.useCallback(() => {
        void validateScreen("CreateMissionJobTitle");
    }, [validateScreen]);

    const origin = useBubbleStepOrigin("CreateMissionJobTitle");

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.translate("next"),
                    onPress: validate,
                    isValid: !!mission.activityType,
                },
            ]}
            withAssistanceButton
        >
            <Bubble title={i18n.t("screens.user.create_mission_job_title.title")} origin={origin}>
                <MissionJobTitle mission={mission} setMission={setMission}></MissionJobTitle>
            </Bubble>
        </ScreenCard>
    );
};

export default CreateMissionJobTitle;
